export const lightGreen = "#D6E3D1";
export const lightBlue = "#E6F2EF";
export const mint = "#C1DFC7";